import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Checkbox, Form, Header, Icon, Message, Modal, Segment, TextArea } from 'semantic-ui-react'
import Loader from '../../loader';
import { DescriptorPair, SchemaDiffUtil } from '../../../utils/schemaDiffUtil';
import { Diff, ReportDiffUtil } from '../../../utils/reportDiffUtil';
import ReviewViewService from '../../../utils/repository/ui/reviewViewService';
import ShemaDiff from './schemaDiff'
import ReportsDiff from './reportsDiff'
import AuthService from '../../../service/auth';
import { ROLES } from '../../../constnats/user';
import ConfirmationModal from '../../confirmationModal';
import { AuthContext } from '../../../App';
import Utils from '../../../utils/descriptor/descriptorUtils';
import TableUpdatesRepo from '../../../utils/repository/tableUpdatesRepo';
import UserRepo from '../../../utils/repository/userRepo';
import { serverToLocalDateTime } from '../../../utils/dateTimeUtils';
import { ReportField } from '../../../constnats/reportConstants';
import { ReportsUtils } from '../../../utils/reportsUtils';
import { ReviewType, UpdatePurpose } from '../../financialTables/configuration/constants';
import DuplicateReportError from '../../../customErrors/duplicateReportsError';
import DescriptorType from '../../../utils/descriptor/descriptorType';
import { DescriptorProps } from '../../../constnats/descriptor';
import { hasFieldsWithoutConfiguredCategory, hasFieldsWithoutStandardizedLabel, isCategorizationRequired, isStandardizedLabelRequired } from '../../../utils/categorization/common';
import TasksRepo from '../../../utils/repository/tasksRepo/tasksRepo';
import { RESPONSE_STATUS } from '../../../constnats/general';
import Alert from '../../../utils/alert';
import TaskModal from '../../admin/task/taskModal';
import './styles.css'
import { TASK_STATUS, TASK_STATUSES, TASK_STATUSES_CONSIDERED_ACTIVE } from '../../../constnats/task';
import EntityTaskExecutionsTable from '../task/entityTaskExecutions/entityTaskExecutionsTable';
import CollectionUtils from '../../../utils/collections';
import Reconciliations from '../reconciliations/reconciliations';
import { BranchTypes } from '../../../constnats/schemaConstants';
import StandardizedLabelsRepo from '../../../utils/repository/standardizedLabelsRepo/standardizedLabelsRepo';
import { getReviewsByUpdateIds } from '../../../service/tableUpdates';
import SchemaRepo from '../../../utils/repository/schemaRepo'
import BranchDiff, { buildBranchComparison, filterTableDiff, hasTableDiffs, resolveEditToReviewSides } from './components/branchDiff';
import { PROVENANCE_PERSPECTIVE, REVIEW_STATUS } from '../../../constnats/review';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import {
    isSourceViewAvailable as sourceViewAvailable,
    ProvenanceSplitLayout,
    SourceViewToggle,
    SourceViewProvider,
} from '../../sourceView';
import { buildProvenanceLookup, EMPTY_PROVENANCE_LOOKUP } from '../../../utils/provenanceUtils';
import { Toggle } from '../../toggleGroup';
import KeyValue from '../../../structures/keyValePair';
import { MODEL_DIFF_PROPERTY } from './components/branchDiff/branchComparisonDetails/constants';
import { resolveTableDiffReportIds } from './components/branchDiff/branchComparisonDetails/reportDiff';

const ERROR_CLASS = 'legend-error'
const ERROR_MISSING_CLASS = 'error-message'

const PERSPECTIVE_OPTIONS = [
    new KeyValue(PROVENANCE_PERSPECTIVE.EDIT, 'Edit'),
    new KeyValue(PROVENANCE_PERSPECTIVE.REVIEW, 'Review'),
]

class ReviewPhase {
    static TABLE_DATA_REMEDIATION = "TABLE_DATA_REMEDIATION"
    static MODEL_REMEDIATION = "MODEL_REMEDIATION"
    static DRAFT_FILLING = "DRAFT_FILLING"
}

class ReviewTab extends React.Component {

    static deleteConfirmationMsg = "Are you sure that you want to delete the review? This operation will also delete all the review model and reports associated to it."

    constructor(props) {
        super(props);
        this.state = {
            review: null,
            schemaDiffs: [],
            reportDiffs: [],
            hasSchemaErrors: true,
            hasDiffErrors: false,
            modal: <></>,
            detailedSchemaDiff: false,
            detailedReportsDiff: false,
            nextPhase: null,
            loading: true,
            hasInvalidFields: false,
            update: null,
            reconciliations: null,
            schemasKnowledge: {},
            reconciliationsDescriptorsMap: {},
            standardizedLabelsMap: {},
            editToReviewSchemaDiffData: null,
            srcToEditSchemaDiffData: null,
            // Temporary inputs for the legacy diff renderer. Remove these four fields with
            // renderDiffArea/SrcToEditDiff once the new branch diff is authoritative.
            srcToEditEditReports: null,
            srcToEditSrcReports: null,
            srcToEditEditSchema: null,
            srcToEditSrcSchema: null,
            reviewReports: null,
            reviewSchema: null,
            sourceViewReports: [],
            flatEditDynamicDescriptors: [],
            sourceViewEnabled: false,
            selectedProvenance: null,
            // Only the legacy fallback uses a single provenance perspective.
            provenancePerspective: PROVENANCE_PERSPECTIVE.REVIEW,
        }

        this.editSchema = null
        this.reviewSchema = null
        this.editReports = null
        this.reviewReports = null
    }

    componentDidMount() {
        //TODO too much duplication
        StandardizedLabelsRepo.listStandardizedLabels((response) => {
            this.setState({ standardizedLabelsMap: CollectionUtils.arrToMap(response.data, a => a.id) }, () => {
                this.refresh();
            });
        });
    }

    refresh() {
        //TODO too much duplication 
        this.setState({ selectedProvenance: null })
        ReviewViewService.getReviewViewData(this.props.reviewId,  async (viewData) => {
            this.loadSchemaDiff(viewData.srcSchema?.id, viewData.editSchema?.id, 'srcToEdit')
            if(viewData.review.type !== ReviewType.VISUAL_CHECK) {
                const { reference, target } = resolveEditToReviewSides({
                    edit: viewData.editSchema,
                    review: viewData.reviewSchema,
                    viewerId: AuthService.getUserId(),
                    reviewOwnerId: viewData.review.ownerId,
                })
                this.loadSchemaDiff(reference?.id, target?.id, 'editToReview')
            }
            const update = viewData.update

            const review = viewData.review
            const phase = review.phase

            const detailedSchemaDiff = phase === ReviewPhase.TABLE_DATA_REMEDIATION
                || phase === ReviewPhase.MODEL_REMEDIATION
            const detailedReportsDiff = phase === ReviewPhase.TABLE_DATA_REMEDIATION
            const summarizedReportsDiff = phase !== ReviewPhase.TABLE_DATA_REMEDIATION

            // The MAIN-branch comparison is rendered live in content() from the stored reports and
            // schemas below, including the report provenance used by Source view.

            let nextPhase = null
            if (phase === ReviewPhase.DRAFT_FILLING) {
                nextPhase = ReviewPhase.MODEL_REMEDIATION
            } else if (review.phase === ReviewPhase.MODEL_REMEDIATION) {
                nextPhase = ReviewPhase.TABLE_DATA_REMEDIATION
            }

            const coreDataDiffOnly = review.type === ReviewType.CORE_DATA_CHECK
            const flatEditDynamicDescriptors = Utils.flatDescriptors(viewData.editSchema.descriptors, true);
            const flatReviewDynamicDescriptors = Utils.flatDescriptors(viewData.reviewSchema?.descriptors ?? [], true);
            const schemasKnowledge = { [viewData.editSchema.id]: {branchType: BranchTypes.EDIT, reviewType: ""} };
            const reviews = await getReviewsByUpdateIds([update.id])
            reviews.forEach((r) => {
                if (r.schemaId) {
                    schemasKnowledge[r.schemaId] = { branchType: BranchTypes.REVIEW, reviewType: r.type };
                }
            });
            const reconciliationsDescriptorsMap = CollectionUtils.arrToMap(
                [...flatEditDynamicDescriptors, ...flatReviewDynamicDescriptors],
                (d) => d.id
            );
            const reconciliations = review.type === ReviewType.VISUAL_CHECK ? (
                    <Reconciliations
                        descriptorsMap={reconciliationsDescriptorsMap}
                        reconciliationEvents={CollectionUtils.toSortedBy(update.reconciliationEvents,(x) => x.schemaId)}
                        schemasKnowledge={schemasKnowledge}
                        restricted={this.props.restricted}
                    />
                ) : null;

            const categorizationRequired = isCategorizationRequired(flatEditDynamicDescriptors)
            const hasNonCategorizedFields = hasFieldsWithoutConfiguredCategory(flatEditDynamicDescriptors)
            const standardizedLabelRequired = isStandardizedLabelRequired(flatEditDynamicDescriptors)
            const hasFieldsMissingLabel = hasFieldsWithoutStandardizedLabel(flatEditDynamicDescriptors)
            this.setState({
                loading: false, review, detailedSchemaDiff, detailedReportsDiff,
                nextPhase, coreDataDiffOnly, update, hasInvalidFields: (categorizationRequired && hasNonCategorizedFields) || (standardizedLabelRequired && hasFieldsMissingLabel),
                reconciliations,
                schemasKnowledge,
                reconciliationsDescriptorsMap,
                srcToEditEditReports: viewData.editReports,
                srcToEditSrcReports: viewData.srcReports,
                // Kept so the provenance layout can request sources for every report on screen.
                srcToEditEditSchema: viewData.editSchema,
                srcToEditSrcSchema: viewData.srcSchema,
                reviewSchema: viewData.reviewSchema,
                reviewReports: viewData.reviewReports,
                sourceViewReports: [
                    ...(viewData.srcReports ?? []),
                    ...(viewData.editReports ?? []),
                    ...(viewData.reviewReports ?? []),
                ],
                editSchema: viewData.editSchema,
                editReports: viewData.editReports,
                srcSchema: viewData.srcSchema,
                srcReports: viewData.srcReports,
                flatEditDynamicDescriptors,
                summarizedReportsDiff,
            })

            if (viewData.reviewReports) {
                this.checkReviewToEditDiff(viewData.editSchema, viewData.reviewSchema,
                    viewData.editReports, viewData.reviewReports, coreDataDiffOnly)
            }
        })
    }

    closeModal = () => {
        this.setState({ modal: <></> })
    }

    openModal(modal) {
        this.setState({ modal })
    }

    // Restricted reviews intentionally keep their existing masking even for employees.
    isSourceViewAvailable() {
        return !this.props.restricted && sourceViewAvailable()
    }

    handleSourceViewToggle = (enabled) => {
        // Turning Source view off clears the current selection so re-entering starts clean.
        this.setState({ sourceViewEnabled: enabled, selectedProvenance: enabled ? this.state.selectedProvenance : null })
    }

    // Switching perspective drops the selection: the panel would otherwise keep showing the side the
    // user just switched away from.
    handlePerspectiveChange = (provenancePerspective) => {
        this.setState({ provenancePerspective, selectedProvenance: null })
    }

    handleValueClick = (provenance) => {
        this.setState({ selectedProvenance: provenance })
    }

    checkReviewToEditDiff(editSchema, reviewSchema, editReports, reviewReports, coreDataDiffOnly) {
        const diffRes = SchemaDiffUtil.schemaDiff(editSchema, reviewSchema, this.state.standardizedLabelsMap, { ignoreCalcs: coreDataDiffOnly })
        const schemaDiffs = diffRes.diffs
        this.setState({ schemaDiffs: schemaDiffs })
        const hasSchemaErrors = schemaDiffs.findIndex(d => d.type === "ERROR") >= 0
        let descriptorPairs = diffRes.descriptorPairs
        try {
            const reportDiffs = ReportDiffUtil.sortReportDiffs(
                ReportDiffUtil.reportsDiff(editReports, reviewReports, descriptorPairs, coreDataDiffOnly),
                true
            );
            this.setState({
                reportDiffs: reportDiffs,
                hasSchemaErrors: false,
                hasDiffErrors: hasSchemaErrors || reportDiffs.length > 0
            })
        } catch (error) {
            console.log(error)
            const hasDiffErrors = error instanceof DuplicateReportError ? true : false
            this.setState({ hasSchemaErrors, hasDiffErrors})
        }
    }

    updateStatus(status) {
        this.update({ status })
    }

    async updatePhase(phase) {
        let tasks = [];
        const taskStatuses = TASK_STATUSES.filter(
            (s) => s !== TASK_STATUS.COMPLETED && s !== TASK_STATUS.PENDING_REVIEW
        );
        if (phase === ReviewPhase.TABLE_DATA_REMEDIATION) {
            tasks = await new Promise((res) => {
                TasksRepo.getTaskExecutionsByEntity(
                    this.state.update.companyId,
                    0,
                    taskStatuses,
                    (response) => {
                        res(response.data?.content);
                    }
                );
            });
        }
        const getTaskExecutionsMessage = (executions) => {
            return executions.length ? 'There are PENDING tasks associated with the company. ' : '';
        };

        const modalMessage = `${getTaskExecutionsMessage(tasks)}Are you sure that you want to proceed to ${phase} phase?`;
        this.openModal(
            <ConfirmationModal
                msg={`${modalMessage}`}
                onConfirm={() => {
                    this.update({ phase });
                    this.closeModal();
                }}
                onCancel={() => this.closeModal()}
            >
                {!!tasks.length && (
                    <EntityTaskExecutionsTable entityId={this.state.update.companyId} statuses={taskStatuses} />
                )}
            </ConfirmationModal>
        );
    }

    transferOwnership() {
        this.openModal(<TransferOwnershipModal ownerId={this.state.review.ownerId}
            onSave={newOwnerId => {
                this.update({ ownerId: newOwnerId })
                this.closeModal()
            }}
            onCancel={() => this.closeModal()} />)
    }

    setNotes() {
        this.openModal(<SetNotesModal notes={this.state.review.notes}
            onSave={newNotes => {
                this.update({ notes: newNotes })
                this.closeModal()
            }}
            onCancel={() => this.closeModal()} />)
    }

    update(updatedProps) {
        this.setState({ loading: true })
        TableUpdatesRepo.getReview(this.state.review.id, review => {
            let currentReview = {
                reviewId: review.id,
                status: review.status,
                phase: review.phase,
                ownerId: review.ownerId,
                notes: review.notes
            }
            TableUpdatesRepo.updateReview(
                Object.assign(currentReview, updatedProps)
                , review => {
                    this.refresh()
                    this.setState({ loading: false })
                    //TODO handle startus change specifically
                    this.props.onReviewStatusChange()
                })
        })
    }

    delete() {
        this.openModal(<ConfirmationModal
            msg={ReviewTab.deleteConfirmationMsg}
            onConfirm={() => TableUpdatesRepo.deleteReview(this.props.reviewId, () => {
                this.props.onDeleted()
            })}
            onCancel={() => this.closeModal()} />)
    }

    createTaskWithExecution = (data) => {
        const taskData = {
            assignedUserId: data.assignedUserId,
            createdById: data.createdById,
            description: data.description,
            dueDate: data.dueDate,
            priority: data.priority,
            title: data.title,
        };

        TasksRepo.createTask(taskData, (taskResponse) => {
            if (taskResponse.status === RESPONSE_STATUS.SUCCESS) {
                Alert.success('Task Created Successfully!');
                TasksRepo.addTaskExecutions(
                    taskResponse.data.id,
                    {
                        taskId: taskResponse.data.id,
                        entities: [{entityId: this.state.update.companyId,
                        entityType: 'Company',}]
                    },
                    (executionResponse) => {
                        if (executionResponse.status === RESPONSE_STATUS.SUCCESS) {
                            Alert.success('Execution created successfully!');

                        } else {
                            Alert.warn(executionResponse.message);
                        }
                    }
                );
            } else {
                Alert.warn(taskResponse.message);
            }
        });
        this.closeModal();
    };

    openCreateTaskModal = () => {
        this.setState({ loading: true }, () => {
            UserRepo.list({ includeDisabled: false }, (users) => {
                this.setState({ loading: false });
                this.openModal(
                    <TaskModal
                        onCancel={this.closeModal}
                        onSave={this.createTaskWithExecution}
                        open={true}
                        users={users}
                        task={{
                            assignedUserId: this.state.update.ownerId,
                            title: `[Update: ${this.state.update.id}] ${this.state.update.summary}`
                        }}
                    />
                );
            });
        })
    }

    loadSchemaDiff = (referenceId, targetId, propName) => {
        this.setState({ [`${propName}SchemaDiffData`]: null });
        if (referenceId == null || targetId == null) {
            return;
        }
        SchemaRepo.diff(referenceId, targetId, (response) => {
            this.setState({ [`${propName}SchemaDiffData`]: resolveTableDiffReportIds(response) });
        });
    }

    isNewReviewDiffClear = () => {
        const { editToReviewSchemaDiffData, editSchema, reviewSchema } = this.state;
        const diff = this.getFilteredTableDiff(editToReviewSchemaDiffData, editSchema, reviewSchema);
        return diff !== null && !hasTableDiffs(diff);
    }

    getFilteredTableDiff = (diff, referenceSchema, targetSchema) => {
        if (diff === null) {
            return null;
        }

        const { coreDataDiffOnly, update } = this.state;
        const ignoredModelDiffProperties = coreDataDiffOnly
            && update?.purpose === UpdatePurpose.MISTAKES_DETECTION
            ? [MODEL_DIFF_PROPERTY.CALCULATION]
            : [];
        const headlineDescriptorIds = [referenceSchema, targetSchema]
            .flatMap(schema => Utils.flatDescriptors(schema?.descriptors ?? []))
            .filter(DescriptorType.isHeadline)
            .map(descriptor => descriptor.id);

        return filterTableDiff(diff, { coreDataDiffOnly, ignoredModelDiffProperties, headlineDescriptorIds });
    }

    qaMarkAsApproved = () => {
        const update = this.state.update;
        TasksRepo.getTaskExecutionsByEntity(update.companyId, 0, TASK_STATUSES_CONSIDERED_ACTIVE, (response) => {
            if (!!response.data?.content?.length) {
                this.openModal(<ConfirmationModal
                    msg={`There are PENDING tasks associated with the company.`}
                    onConfirm={() => {
                        this.updateStatus(REVIEW_STATUS.APPROVED);
                        this.closeModal();
                    }}
                    onCancel={() => this.closeModal()}
                >
                    <EntityTaskExecutionsTable entityId={update.companyId} statuses={TASK_STATUSES_CONSIDERED_ACTIVE} />
                </ConfirmationModal>);
            }else {
                this.updateStatus(REVIEW_STATUS.APPROVED);
            }
        });
    }

    actions() {
        const review = this.state.review
        const reviewStatus = review.status
        const fastTrackReviewer = AuthService.hasRole(this.context, ROLES.DO_FAST_TRACK_REVIEWS)
        const getChangeReviewStatusBtn = (newStatus, changeHandler = (newStatus) => this.updateStatus(newStatus)) =>
            <Button key={newStatus} onClick={() => changeHandler(newStatus)} size='mini' primary>Change status to {newStatus}</Button>
        const buttons = []

        const transferOwnershipBtn = <Button key="transferOwnership" size='mini'
            onClick={() => this.transferOwnership()}>
            Transfer Ownership
        </Button>

        if (review.ownerId === AuthService.getUserId()) {
            if (reviewStatus !== REVIEW_STATUS.REJECTED && review.phase !== ReviewPhase.DRAFT_FILLING) {
                buttons.push(getChangeReviewStatusBtn(REVIEW_STATUS.REJECTED))
            }

            if (this.state.nextPhase) {
                buttons.push(
                    <Button key="enableDiffCheck" size='mini' primary
                        onClick={() => this.updatePhase(this.state.nextPhase)}>
                        Start {this.state.nextPhase}
                    </Button>)
            } else {
                if (reviewStatus !== REVIEW_STATUS.IN_PROGRESS) {
                    buttons.push(getChangeReviewStatusBtn(REVIEW_STATUS.IN_PROGRESS))
                } else if (!this.state.hasInvalidFields) {
                    if (review.type === "VISUAL_CHECK") {
                        buttons.push(getChangeReviewStatusBtn(REVIEW_STATUS.APPROVED, this.qaMarkAsApproved))
                    } else {
                        if ((fastTrackReviewer || (this.isNewReviewDiffClear() && !this.state.hasDiffErrors))
                            && reviewStatus !== REVIEW_STATUS.APPROVED) {
                            buttons.push(getChangeReviewStatusBtn(REVIEW_STATUS.APPROVED))
                        }
                    }
                }
            }

            buttons.push(
                <Button key="setNotes" size='mini'
                    onClick={() => this.setNotes()}>
                    Set Notes
                </Button>)

            buttons.push(transferOwnershipBtn)
        }


        if (AuthService.hasAnyGlobalRole([ROLES.REVIEWS_MANAGER])) {
            buttons.push(
                <Button key="delete" onClick={() => this.delete()} size='mini' color='red'>
                    Delete
                </Button>)
            if (!buttons.includes(transferOwnershipBtn)) {
                buttons.push(transferOwnershipBtn)
            }
        }

        if (review.type === ReviewType.VISUAL_CHECK) {
            buttons.push(
                <Button key='createTask' size='mini' onClick={this.openCreateTaskModal}>
                    Create Task
                </Button>
            );
        }

        return buttons
    }

    content() {
        const state = this.state
        const review = this.state.review
        const update = state.update
        const reportsForDeferredCheck = update.reportsForDeferredCheck
        const restricted = this.props.restricted
        const sourceViewAvailable = this.isSourceViewAvailable()
        const sourceViewEnabled = sourceViewAvailable && state.sourceViewEnabled
        const showLegacyFallback = review.type !== ReviewType.VISUAL_CHECK
            && this.isNewReviewDiffClear()
            && state.hasDiffErrors
        const showLegacyRenderer = restricted || showLegacyFallback
        return <div>
            <Icon color='grey' size='large' name='refresh'
                className='cursorPointer floatRight'
                onClick={() => this.refresh()} />
            {sourceViewAvailable && (
                <div className='review__source-controls floatRight'>
                    <SourceViewToggle enabled={sourceViewEnabled} onChange={this.handleSourceViewToggle} />
                    {sourceViewEnabled && showLegacyRenderer && (
                        <Toggle
                            activeValue={state.provenancePerspective}
                            onChange={this.handlePerspectiveChange}
                            options={PERSPECTIVE_OPTIONS} />
                    )}
                </div>
            )}
            {state.modal}
            <b>ID:</b> {review.id}<br />
            <b>Status:</b> {review.status}<br />
            <b>Phase:</b> {review.phase}<br />
            <b>Type:</b> {review.type}<br />
            <b>Resets:</b> {review.resetsCount}<br />
            <b>Created On:</b> {serverToLocalDateTime(review.createdOn)}<br />
            <b>Updated On:</b> {serverToLocalDateTime(review.updatedOn)}<br />
            <b>Company ID:</b> {update.companyId}<br />
            {reportsForDeferredCheck?.length > 0 && <><b>Reports for correctness check:</b> {reportsForDeferredCheck.join(" ,")}<br /></>}
            <Segment>
                <b>Update Summary:</b> {update.summary}<br />
                <b>Update Description:</b> {<div dangerouslySetInnerHTML={{ __html: update.description.replace(/(?:\r\n|\r|\n)/g, '</br>') }}></div>}</Segment>
            {this.renderReviewDifferences(sourceViewEnabled, showLegacyRenderer)}
            <br />
            {review.notes && (
                <Segment>
                    <b>Notes:</b>
                    <div className="review-notes-markdown">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>{review.notes}</ReactMarkdown>
                    </div>
                </Segment>
            )}
            {!restricted && this.actions()}
        </div>
    }

    renderReviewDifferences(sourceViewEnabled, showLegacyRenderer) {
        const state = this.state
        const review = state.review
        const update = state.update

        // Restricted reviews retain their legacy masking, and the existing diff-error fallback
        // still uses the legacy renderer. Source view itself stays on the new branch differences.
        if (showLegacyRenderer) {
            return this.renderDiffArea(sourceViewEnabled)
        }

        const mainBranch = {
            type: BranchTypes.MAIN,
            schema: state.srcSchema,
            reports: state.srcReports,
        }
        const editBranch = {
            type: BranchTypes.EDIT,
            schema: state.editSchema,
            reports: state.editReports,
        }
        const reviewBranch = {
            type: BranchTypes.REVIEW,
            schema: state.reviewSchema,
            reports: state.reviewReports,
        }
        const { reference, target } = resolveEditToReviewSides({
            edit: editBranch,
            review: reviewBranch,
            viewerId: AuthService.getUserId(),
            reviewOwnerId: review.ownerId,
        })
        const editToReviewComparison = buildBranchComparison({
            tableDiff: this.getFilteredTableDiff(state.editToReviewSchemaDiffData, reference.schema, target.schema),
            referenceBranch: reference,
            targetBranch: target,
            modelDetailsAvailable: state.detailedSchemaDiff,
            reportsAvailable: state.detailedReportsDiff,
            reportsChangesPreviewAvailable: review.phase === ReviewPhase.MODEL_REMEDIATION,
        })
        const invalidFields = getInvalidFields(
            state.flatEditDynamicDescriptors,
            isCategorizationRequired(state.flatEditDynamicDescriptors),
            isStandardizedLabelRequired(state.flatEditDynamicDescriptors),
        ).map(f => ({ descriptorId: f.descriptor.id, label: f.descriptor.label, message: f.message }))
        const mainToEditComparison = buildBranchComparison({
            tableDiff: this.getFilteredTableDiff(state.srcToEditSchemaDiffData, mainBranch.schema, editBranch.schema),
            referenceBranch: mainBranch,
            targetBranch: editBranch,
            modelDetailsAvailable: state.detailedSchemaDiff,
            reportsAvailable: state.detailedReportsDiff,
        })
        const reconciliationEvents = review.type === ReviewType.VISUAL_CHECK
            ? CollectionUtils.toSortedBy(update.reconciliationEvents ?? [], (x) => x.schemaId)
            : undefined

        return <SourceViewProvider sourceViewEnabled={sourceViewEnabled}
            onValueClick={this.handleValueClick} reports={state.sourceViewReports}>
            <ProvenanceSplitLayout enabled={sourceViewEnabled}
                containerRef={this.props.containerRef?.current?.dimmerRef}
                provenance={state.selectedProvenance}>
                <BranchDiff
                    invalidFields={invalidFields}
                    editToReviewComparison={editToReviewComparison}
                    mainToEditComparison={mainToEditComparison}
                    coreDataDiffOnly={state.coreDataDiffOnly}
                    companyId={update.companyId}
                    reconciliation={reconciliationEvents ? {
                        events: reconciliationEvents,
                        descriptorsMap: state.reconciliationsDescriptorsMap,
                        schemasKnowledge: state.schemasKnowledge,
                    } : undefined}
                />
            </ProvenanceSplitLayout>
        </SourceViewProvider>
    }

    renderDiffArea(sourceViewEnabled) {
        const state = this.state
        const review = state.review
        const update = state.update
        const restricted = this.props.restricted
        const visualCheck = review.type === "VISUAL_CHECK"
        const schemaDiffs = state.schemaDiffs
        const reportDiffs = state.reportDiffs

        // Indexed over every report on screen rather than only the ones that differ: the MAIN-branch
        // comparison computes its own diffs internally, so the differing set is not available here.
        // Unlike the financial tables, the review's reports always arrive with their provenance —
        // there is nothing to re-fetch, so this is only skipped to save the indexing pass.
        const getProvenance = sourceViewEnabled
            ? buildProvenanceLookup([
                ...(state.srcToEditEditReports ?? []),
                ...(state.reviewReports ?? []),
                ...(state.srcToEditSrcReports ?? []),
            ])
            : EMPTY_PROVENANCE_LOOKUP

        const reviewBody = <>
            {!visualCheck && <ReviewToEditDiff {...{ schemaDiffs, reportDiffs }}
                summarizedReportsDiff={state.summarizedReportsDiff}
                detailedSchemaDiff={state.detailedSchemaDiff}
                detailedReportsDiff={state.detailedReportsDiff}
                hasSchemaErrors={state.hasSchemaErrors}
                restricted={restricted}
                sourceViewEnabled={sourceViewEnabled}
                getProvenance={getProvenance}
                onValueClick={this.handleValueClick}
                perspective={state.provenancePerspective}
                companyId={update.companyId} />}

            {state.detailedSchemaDiff && <SrcToEditDiff
                editSchema={state.srcToEditEditSchema}
                srcSchema={state.srcToEditSrcSchema}
                editReports={state.srcToEditEditReports}
                srcReports={state.srcToEditSrcReports}
                companyId={update.companyId}
                restricted={restricted}
                detailed={state.detailedReportsDiff}
                sourceViewEnabled={sourceViewEnabled}
                getProvenance={getProvenance}
                onValueClick={this.handleValueClick}
                perspective={state.provenancePerspective} />}

            {state.reconciliations}
        </>

        return <ProvenanceSplitLayout
            enabled={sourceViewEnabled}
            containerRef={this.props.containerRef?.current?.dimmerRef}
            provenance={state.selectedProvenance}>
            {reviewBody}
        </ProvenanceSplitLayout>
    }

    render() {
        return this.state.loading ? <Loader /> : this.content()
    }
}

function ReviewToEditDiff({ schemaDiffs, reportDiffs, detailedSchemaDiff,
    detailedReportsDiff, hasSchemaErrors, companyId, summarizedReportsDiff, restricted,
    sourceViewEnabled, getProvenance, onValueClick, perspective }) {
    return <Segment className='bg-darkgrey'>
        <Header as="h5" textAlign='center'>EDIT Branch Comparison</Header>


        {detailedSchemaDiff ? <ShemaDiff {...{ schemaDiffs }} /> :
            <Header as="h5">Model Differences:  {schemaDiffs.length}</Header>}
        {detailedReportsDiff ? <ReportsDiff
            schemaErrors={hasSchemaErrors}
            reportDiffs={reportDiffs}
            editName="EDIT"
            reviewName="REVIEW"
            companyId={companyId}
            summarized={false}
            restricted={restricted}
            sourceViewEnabled={sourceViewEnabled}
            getProvenance={getProvenance}
            onValueClick={onValueClick}
            perspective={perspective}
            detailed={detailedReportsDiff} /> :
            <>
                <Header as="h5">Detailed Report Differences
                </Header>
                <Message error attached='bottom'>
                    Not available in this phase </Message>
            </>}
        {/* The summary has no value columns, but it does have the descriptor labels the sources now
            hang off — so it is inspectable in the phases where it is the only table on screen. */}
        {summarizedReportsDiff && <ReportsDiff
            heading={"Report Differences Summary"}
            schemaErrors={hasSchemaErrors}
            reportDiffs={reportDiffs}
            editName="EDIT"
            reviewName="REVIEW"
            companyId={companyId}
            summarized={summarizedReportsDiff}
            restricted={restricted}
            sourceViewEnabled={sourceViewEnabled}
            getProvenance={getProvenance}
            onValueClick={onValueClick}
            perspective={perspective}
            detailed={false} />}

    </Segment>
}

function reportKey(report) {
    return report.year + report.period + report.reportType + report.type
}

function getInvalidFields(flatDynamicDescriptors, categorizationRequired, standardizedLabelRequired) {
    const invalidFields = []
    for (const descriptor of flatDynamicDescriptors) {
        /**
         * TODO: here the first condition !d[DescriptorProps.CATEGORY] in the callback function should be removed
         * after a migration
         * Currently this is needed to account for descriptors with categories and with a category configured property
         * of false.
         * After the migration all descriptors with categories will have their category configured prop set to true and
         * the additional check will be obsolete
         */
        if (categorizationRequired && !descriptor[DescriptorProps.CATEGORY] && !descriptor[DescriptorProps.CATEGORY_CONFIGURED] && !DescriptorType.isHeadline(descriptor)) {
            invalidFields.push({ descriptor, message: "The field needs to be categorized" })
        }
        if (standardizedLabelRequired && !descriptor[DescriptorProps.STANDARDIZED_LABEL_RELATION]?.standardizedLabelId && !DescriptorType.isHeadline(descriptor)) {
            invalidFields.push({ descriptor, message: "The field needs a standardized label" })
        }
    }
    return invalidFields
}

function InvalidField({ field }) {
    return (
        <li>
            <span className={ERROR_CLASS}>{field.descriptor.label}</span> <span className={ERROR_MISSING_CLASS}>{field.message}</span>
        </li>
    )
}

function SrcToEditDiff({ editSchema, srcSchema, editReports,
    srcReports, companyId, detailed, restricted, sourceViewEnabled, getProvenance, onValueClick,
    perspective }) {

    /**
     * When true this ignores extended search when the old value is false and the new value is true
     */
    const [ignoreExtendedSearchEnablement, setIgnoreExtendedSearchEnablement] = useState(true)
    srcReports = JSON.parse(JSON.stringify(srcReports))

    const srcReportKeys = srcReports.map(reportKey)

    const srcDescriptorPairs = []
    const flatSrcDescriptors = Utils.flatDescriptors(srcSchema.descriptors)

    for (const descriptor of flatSrcDescriptors) {
        srcDescriptorPairs.push(new DescriptorPair(descriptor, descriptor))
    }

    const addedFields = []
    const flatEditDescriptors = Utils.flatDescriptors(editSchema.descriptors)
    const flatEditDynamicDescriptors = flatEditDescriptors.filter(d => d[DescriptorProps.DYNAMIC])
    const addedDescriptorPairs = []
    const categorizationRequired = isCategorizationRequired(flatEditDescriptors);
    const standardizedLabelRequired = isStandardizedLabelRequired(flatEditDynamicDescriptors)
    const invalidFields = getInvalidFields(flatEditDynamicDescriptors, categorizationRequired, standardizedLabelRequired)

    for (const descriptor of flatEditDescriptors) {
        if (flatSrcDescriptors.findIndex(d => descriptor.id === d.id) < 0) {
            addedFields.push(descriptor)
            addedDescriptorPairs.push(new DescriptorPair(descriptor, descriptor))
        }
    }

    const removedFields = []
    for (const descriptor of flatSrcDescriptors) {
        if (flatEditDescriptors.findIndex(d => descriptor.id === d.id) < 0) {
            removedFields.push(descriptor)
        }
    }

    const editReportsWithSrc = []
    const editReportsWithoutSrc = []
    for (const report of editReports) {
        if (srcReportKeys.includes(reportKey(report))) {
            editReportsWithSrc.push(report)
        } else {
            editReportsWithoutSrc.push(report)
        }
    }

    for (const descriptor of removedFields) {
        for (const r of editReportsWithSrc) {
            //This is needed in order to present the values of he removed fields in the Report Differences
            delete r.dynamicFields[descriptor.id]
            delete r[ReportField.METADATA].fieldSpecific[descriptor.id]
        }
    }

    /**
     * Covers the intersection between src reports and src descriptor pairs.
     */
    let srcReportsDiff = ReportDiffUtil
        .reportsDiff(editReportsWithSrc, srcReports, srcDescriptorPairs, false, true, ignoreExtendedSearchEnablement)

    /**
     * Covers the intersection between src reports and added descriptor pairs.
     */
    const addedReportsDiff = ReportDiffUtil
        .reportsDiff(editReportsWithSrc, srcReports, addedDescriptorPairs, false, true, ignoreExtendedSearchEnablement)
        .filter(d => d.fieldLabel !== "N/A")
    addedReportsDiff.forEach(d => d.type = Diff.WARNING)
    srcReportsDiff.push(...addedReportsDiff)
    srcReportsDiff = ReportDiffUtil.sortReportDiffs(srcReportsDiff,true)

    const labelRenamings = []
    for (const srcDescriptor of flatSrcDescriptors) {
        if (removedFields.findIndex(d => d.id === srcDescriptor.id) < 0) {
            const editDescriptor = flatEditDescriptors.find(d => d.id === srcDescriptor.id)
            if (editDescriptor && (editDescriptor.label != srcDescriptor.label)) {
                labelRenamings.push(srcDescriptor.label + " => " + editDescriptor.label)
            }
        }
    }

    return <Segment secondary>
        <Header as="h5">MAIN Branch Comparison</Header>
        <div>
            <Checkbox onChange={() => setIgnoreExtendedSearchEnablement(prev => !prev)} checked={ignoreExtendedSearchEnablement}
            label="Ignore extended search enablement"/>
        </div>
        <b>Renamed Fields</b>
        {labelRenamings.length > 0 ?
            <ul>
                {labelRenamings.map((d, i) => <li key={i}><span className='warning'>{d}</span></li>)}
            </ul> : <><br />No Renamed Fields</>}

        <br />
        <b>Added Fields</b>
        {addedFields.length > 0 ?
            <ul>
                {addedFields.map(d =>
                    <li key={d.id}>{d.label}</li>
                )}
            </ul> : <><br />No Added Fields</>}
        <br />
        <b>Removed Fields</b>
        {removedFields.length > 0 ?
            <ul>
                {removedFields.map(d => <li key={d.id}><span className='danger'>{d.label}</span></li>)}
            </ul> :
            <><br />No Removed Fields</>
        }
        {invalidFields.length > 0 ?
            <>
                <br />
                <b>Invalid Fields</b>
                <ul>
                    {invalidFields.map(field => <InvalidField key={field.descriptor.id} field={field} />)}
                </ul>
            </>
            : <></>
        }
        <br />
        <b>Added Reports</b>
        {editReportsWithoutSrc.length > 0 ?
            <ul>
                {ReportsUtils.sort(editReportsWithoutSrc).map(r => <li key={r.id}>{getReportName(r)}</li>)}
            </ul> :
            <><br />No Added Reports</>
        }
        <ReportsDiff
            schemaErrors={false}
            reportDiffs={srcReportsDiff}
            editName="EDIT"
            reviewName="MAIN"
            detailed={detailed}
            restricted={restricted}
            sourceViewEnabled={sourceViewEnabled}
            getProvenance={getProvenance}
            onValueClick={onValueClick}
            perspective={perspective}
            companyId={companyId} />
    </Segment>
}

ReviewTab.contextType = AuthContext;

function getReportName(report) {
    return report[ReportField.YEAR] + "/" + report[ReportField.PERIOD] +
        "/" + report[ReportField.TYPE] + "/" + report[ReportField.REPORT_TYPE]
}

function TransferOwnershipModal({ ownerId, onSave, onCancel }) {
    let [users, setUsers] = useState([])
    let [_ownerId, setOwnerId] = useState(ownerId)

    useEffect(() => {
        UserRepo.list(
            { userRoles: [ROLES.EMPLOYEE], includeDisabled: false },
            users =>
                setUsers(
                    users.map(r => {
                        return {
                            key: r.id,
                            text: r.fullName,
                            value: r.id
                        }
                    }))
        )
    },[])

    function save() {
        onSave(_ownerId)
    }

    return <Modal size="mini" open={true}>
        <Modal.Header>Transfer Ownership</Modal.Header>
        <Modal.Content>
            <Form>
                <Form.Field>
                    <label>Owner</label>
                    <Dropdown
                        onChange={(a, b) => setOwnerId(b.value)}
                        value={_ownerId}
                        placeholder="Owner"
                        options={users}
                        fluid selection search />
                </Form.Field>
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button size='mini' positive onClick={save}>
                Transfer
            </Button>
            <Button size='mini' negative onClick={onCancel}>
                Cancel
            </Button>
        </Modal.Actions>
    </Modal >
}

const INVALID_NOTES_MSG = 'The notes must not be more than 200 characters.'

function SetNotesModal({ notes, onSave, onCancel }) {
    const [_notes, setNotes] = useState(notes === null ? "" : notes)
    const [error, setError] = useState(false)

    function onNotesChange(notes) {
        if (notes.length > 200) {
            setError({ content: INVALID_NOTES_MSG })
        } else {
            setError(false)
        }
        setNotes(notes)
    }

    function save() {
        if (error === false) {
            onSave(_notes)
        }
    }

    return <Modal size="mini" open={true}>
        <Modal.Header>Notes</Modal.Header>
        <Modal.Content>
            <Form>
                <Form.Field
                    error={error}
                    control={TextArea}
                    value={_notes} onChange={v =>
                        onNotesChange(v.target.value)
                    } />
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button size='mini' positive onClick={(save)}>
                Save
            </Button>
            <Button size='mini' negative onClick={onCancel}>
                Cancel
            </Button>
        </Modal.Actions>
    </Modal >
}

export default ReviewTab
